var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.loading)?_c('b-skeleton'):_c('Check',{attrs:{"value":_vm.appointmentPrintables.print_statement_of_awareness,"label":"Declaração de ciência da realização de procedimento/exame"},on:{"change":checked => _vm.updateAppointmentPrintables('print_statement_of_awareness', checked)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }